import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getComprasDeUsuario } from 'services/servicioGet';
import { CompraBase } from 'utils/models/types';

interface ComprasState {
  comprasDeUsuario: CompraBase[];
  loadingComprasDeUsuario: boolean;
  errorComprasDeusuario: string | null;
}

// Estado inicial del slice
const initialState: ComprasState = {
  comprasDeUsuario: [],
  loadingComprasDeUsuario: false,
  errorComprasDeusuario: null,
};

// Thunk para obtener las compras del usuario
export const fetchComprasDeUsuario = createAsyncThunk<
  CompraBase[],
  number, // Id del usuario
  { rejectValue: string }
>('compras/fetchComprasDeUsuario', async (id, thunkAPI) => {
  try {
    const response = await getComprasDeUsuario(id.toString());
    return response;
  } catch (error) {
    return thunkAPI.rejectWithValue('Error al cargar las compras');
  }
});

// Slice de compras
const comprasDeUsuarioSlice = createSlice({
  name: 'comprasUsuario',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(fetchComprasDeUsuario.pending, state => {
        state.loadingComprasDeUsuario = true;
        state.errorComprasDeusuario = null;
      })
      .addCase(fetchComprasDeUsuario.fulfilled, (state, action) => {
        state.comprasDeUsuario = action.payload;
        state.loadingComprasDeUsuario = false;
      })
      .addCase(fetchComprasDeUsuario.rejected, (state, action) => {
        state.loadingComprasDeUsuario = false;
        state.errorComprasDeusuario = action.payload as string;
      });
  },
});

export default comprasDeUsuarioSlice.reducer;
